"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
const react_1 = require("react");
const provider_type_1 = require("@dcl/schemas/dist/dapps/provider-type");
const ConnectionManager_1 = require("decentraland-connect/dist/ConnectionManager");
const logger_1 = __importDefault(require("../entities/Development/logger"));
const storage_1 = require("../utils/auth/storage");
const rollbar_1 = __importDefault(require("../utils/development/rollbar"));
const segment_1 = __importDefault(require("../utils/development/segment"));
const types_1 = require("../utils/loader/types");
const useAsyncTask_1 = __importDefault(require("./useAsyncTask"));
const useAuth_utils_1 = require("./useAuth.utils");
Object.defineProperty(exports, "initialState", { enumerable: true, get: function () { return useAuth_utils_1.initialState; } });
let CONNECTION_PROMISE = null;
function useAuth() {
    const [state, setState] = (0, react_1.useState)(Object.assign({}, useAuth_utils_1.initialState));
    const select = (0, react_1.useCallback)((selecting = true) => {
        if ((0, useAuth_utils_1.isLoading)(state.status)) {
            return;
        }
        if (selecting === state.selecting) {
            return;
        }
        setState((current) => (Object.assign(Object.assign({}, current), { selecting })));
    }, [state]);
    const connect = (0, react_1.useCallback)((providerType, chainId) => {
        if ((0, useAuth_utils_1.isLoading)(state.status)) {
            return;
        }
        if (state.account) {
            console.warn(`Already connected as "${state.account}"`);
            return;
        }
        const conn = { providerType: providerType, chainId: chainId };
        if (!providerType || !chainId) {
            console.error(`Invalid connection params: ${JSON.stringify(conn)}`);
            (0, rollbar_1.default)((rollbar) => rollbar.error(`Invalid connection params: ${JSON.stringify(conn)}`));
            (0, segment_1.default)((analytics) => analytics.track('error', {
                message: `Invalid connection params: ${JSON.stringify(conn)}`,
                conn,
            }));
            return;
        }
        (0, segment_1.default)((analytics, context) => analytics.track(useAuth_utils_1.AuthEvent.Connect, Object.assign(Object.assign({}, context), conn)));
        setState({
            account: null,
            identity: null,
            provider: null,
            error: null,
            selecting: state.selecting,
            status: useAuth_utils_1.AuthStatus.Connecting,
            providerType,
            chainId,
        });
    }, [state]);
    const disconnect = (0, react_1.useCallback)(() => {
        if ((0, useAuth_utils_1.isLoading)(state.status)) {
            return;
        }
        if (!state.account) {
            return;
        }
        setState({
            status: useAuth_utils_1.AuthStatus.Disconnecting,
            account: null,
            identity: null,
            provider: null,
            error: null,
            selecting: false,
            providerType: null,
            chainId: null,
        });
    }, [state]);
    const [switching, switchTo] = (0, useAsyncTask_1.default)((chainId) => __awaiter(this, void 0, void 0, function* () {
        if (state.providerType === provider_type_1.ProviderType.INJECTED) {
            try {
                yield (0, useAuth_utils_1.switchToChainId)(state.provider, chainId);
            }
            catch (err) {
                setState(Object.assign(Object.assign({}, state), { error: err.message }));
            }
        }
    }), [state]);
    // bootstrap
    (0, react_1.useEffect)(() => {
        let cancelled = false;
        function updateIdetity(newIdentity) {
            if (!cancelled) {
                setState((currentState) => {
                    if (currentState.identity === newIdentity) {
                        return currentState;
                    }
                    if (newIdentity) {
                        return {
                            status: useAuth_utils_1.AuthStatus.Restoring,
                            selecting: false,
                            account: null,
                            identity: null,
                            provider: null,
                            providerType: null,
                            chainId: null,
                            error: null,
                        };
                    }
                    return {
                        status: useAuth_utils_1.AuthStatus.Disconnecting,
                        selecting: false,
                        account: null,
                        identity: null,
                        provider: null,
                        providerType: null,
                        chainId: null,
                        error: null,
                    };
                });
            }
        }
        (0, useAuth_utils_1.getListener)().addEventListener(types_1.PersistedKeys.Identity, updateIdetity);
        return () => {
            cancelled = true;
            (0, useAuth_utils_1.getListener)().removeEventListener(types_1.PersistedKeys.Identity, updateIdetity);
        };
    }, []);
    // connect or disconnect
    (0, react_1.useEffect)(() => {
        let cancelled = false;
        if (state.status === useAuth_utils_1.AuthStatus.Restoring) {
            if (!CONNECTION_PROMISE) {
                CONNECTION_PROMISE = (0, useAuth_utils_1.restoreConnection)();
            }
            Promise.resolve(CONNECTION_PROMISE)
                .then((result) => {
                if (!cancelled) {
                    setState(result);
                }
                CONNECTION_PROMISE = null;
            })
                .catch((err) => {
                logger_1.default.error('Error restoring session', err);
                CONNECTION_PROMISE = null;
            });
        }
        // connect
        if (state.status === useAuth_utils_1.AuthStatus.Connecting &&
            state.providerType &&
            state.chainId) {
            if (!CONNECTION_PROMISE) {
                CONNECTION_PROMISE = (0, useAuth_utils_1.createConnection)(state.providerType, state.chainId);
            }
            Promise.resolve(CONNECTION_PROMISE)
                .then((result) => {
                if (!cancelled) {
                    if (result.status === useAuth_utils_1.AuthStatus.Connected) {
                        const conn = {
                            account: result.account,
                            ethAddress: result.account,
                            providerType: state.providerType,
                            chainId: state.chainId,
                        };
                        (0, segment_1.default)((analytics, context) => {
                            analytics.identify(conn);
                            analytics.track(useAuth_utils_1.AuthEvent.Connected, Object.assign(Object.assign({}, context), conn));
                        });
                        (0, rollbar_1.default)((rollbar) => {
                            rollbar.configure({
                                payload: {
                                    person: {
                                        id: conn.account,
                                    },
                                },
                            });
                        });
                    }
                    else {
                        result.selecting = state.selecting;
                    }
                    setState(result);
                }
                CONNECTION_PROMISE = null;
            })
                .catch((err) => {
                CONNECTION_PROMISE = null;
                logger_1.default.error('Error creating session', err);
            });
        }
        // disconnect
        if (state.status === useAuth_utils_1.AuthStatus.Disconnecting &&
            state.providerType === null &&
            state.chainId === null) {
            (0, storage_1.setCurrentIdentity)(null);
            ConnectionManager_1.connection.disconnect().catch((err) => {
                console.error(err);
                (0, rollbar_1.default)((rollbar) => rollbar.error(err));
                (0, segment_1.default)((analytics) => analytics.track('error', Object.assign(Object.assign({}, err), { message: err.message, stack: err.stack })));
            });
            (0, segment_1.default)((analytics, context) => analytics.track(useAuth_utils_1.AuthEvent.Disconnected, context));
            (0, rollbar_1.default)((rollbar) => rollbar.configure({ payload: { person: { id: null } } }));
            setState(Object.assign(Object.assign({}, useAuth_utils_1.initialState), { status: useAuth_utils_1.AuthStatus.Disconnected }));
        }
        return () => {
            cancelled = true;
        };
    }, [state]);
    (0, react_1.useEffect)(() => {
        const provider = state.provider;
        const onDisconnect = () => disconnect();
        const onChainChanged = (chainId) => setState(Object.assign(Object.assign({}, state), { chainId: Number(chainId) }));
        if (provider && !provider.isFortmatic) {
            if (provider.on) {
                provider.on('chainChanged', onChainChanged);
                provider.on('accountsChanged', onDisconnect);
                provider.on('disconnect', onDisconnect);
            }
            else if (provider.addListener) {
                provider.addListener('chainChanged', onChainChanged);
                provider.addListener('accountsChanged', onDisconnect);
                provider.addListener('disconnect', onDisconnect);
            }
        }
        return () => {
            if (provider && !provider.isFortmatic) {
                if (provider.off) {
                    provider.off('chainChanged', onChainChanged);
                    provider.off('accountsChanged', onDisconnect);
                    provider.off('disconnect', onDisconnect);
                }
                else if (provider.removeListener) {
                    provider.removeListener('chainChanged', onChainChanged);
                    provider.removeListener('accountsChanged', onDisconnect);
                    provider.removeListener('disconnect', onDisconnect);
                }
            }
        };
    }, [state]);
    const loading = (0, useAuth_utils_1.isLoading)(state.status) || switching;
    const actions = (0, react_1.useMemo)(() => ({
        connect,
        disconnect,
        switchTo,
        select,
        loading,
        error: state.error,
        selecting: state.selecting,
        provider: !loading ? state.provider : null,
        providerType: !loading ? state.providerType : null,
        chainId: !loading ? state.chainId : null,
    }), [connect, disconnect, switchTo, select, loading, state]);
    return [state.account, actions];
}
exports.default = useAuth;
